<script>
	import { api } from "../api";
	import { useNavigate } from 'svelte-navigator'
	import FlightEntry from "../components/FlightEntry.svelte";
	import FilterBar from "../components/FilterBar.svelte";
	import Bounds from "../flight/Bounds.svelte";
  import SrsMonitor from "../components/SRSMonitor.svelte";

	const flights = api.flights.store;
	const promise = api.flights.get();
	const navigate = useNavigate()

	let filter = ''
	let showHiddenFlights = false
	let settingsOpen = false;

	$: filteredFlights = filterFlights($flights, filter, showHiddenFlights)

	function newFlight() {
		navigate('/flights/new?name=' + filter)
	}

	function filterFlights(inFlights, inFilter, showHidden) {
		const ret = Object.values(inFlights)
			.filter(f => !f.isHidden || showHidden)
			.filter(a => a.name.toLowerCase().includes(inFilter.toLowerCase()))
			.sort(flightSorter)
		return ret
	}

	const stateValues = ["ENDED", "ACTIVE", "INITIALIZING", "READY"];
	function flightSorter(a, b) {
		const aState = stateValues.indexOf(a.state) || 0;
		const bState = stateValues.indexOf(b.state) || 0;
		if (aState === bState) {
			return b.id - a.id;
		} else {
			return bState - aState;
		}
	}

	function settingsClicked() {
		settingsOpen = !settingsOpen;
	}
</script>

<svelte:head>
	 <title>SkyLine - Flights</title>
</svelte:head>

{#await promise then _}
	<div class="sidebar">
		<div class="sidebar-tile flightSelector">
			<div class="filterContainer">
				<FilterBar bind:filter newUrl="/flights/new" />
				<div class="settingsContainer">
					<img src="/images/settings-2.svg" alt="Settings slider icon" width="24 px" height="24 px" on:click={settingsClicked} />
				</div>
			</div>
			<div class="flight-list">
				{#each filteredFlights as flight (flight.id)}
					<FlightEntry flight={flight} />
					{#if flight.state === "ACTIVE" && flight.bounds}
						<Bounds staticBounds={flight.bounds} />
					{/if}
				{:else}
					{#if filter}
						<div class="createMessage" on:click={newFlight}>
							No flights found with this name, click to create it.
						</div>
					{/if}
				{/each}
			</div>
			<div  class={`hideOffline ${settingsOpen ? 'mobileSettings' : ''}`}>
				<div class='showHidden'>
					<label><input type='checkbox' bind:checked={showHiddenFlights}>Show hidden flights</label>
				</div>
			</div>

		</div>
	</div>
{/await}

<SrsMonitor />

<style>
	.filterContainer {
		display: flex;
		order: 1;

	}
	.settingsContainer {
		display: none;
	}

	.flight-list {
		margin-top: 8px;
		order: 2;
	}
	.flight-entry {
		cursor: pointer;
	}
	.clearSearch {
		cursor: pointer;
	}

	.sidebar {
		background-color: rgb(37 37 37);
	}

	.showHidden {
		margin-top:8px;
		color:gray;
	}

	.showHidden input {
		margin-right:4px;
	}

	.hideOffline {
		flex: 1;
		text-align: left;
		color: white;
		order: 3;
	}
	@media only screen and (max-width: 600px) { 
		.settingsContainer {
			display: flex;
    	align-items: center;
			margin-left: 5px;
		}

		.flight-list {
			order: 3;
		}
		.mobileSettings {
			display: flex !important; 
		}

		.hideOffline {
			display: none;
			justify-content: space-around;
			margin-top: 10px;
			order: 2;
		}

		label {
			display: flex;
			align-items: center;
			text-transform: uppercase;
		}
		.hideOffline input {
			margin-right: 8px;
			height: 20px;
			width: 20px;
		}
	}
</style>
